import axios from "axios";

const BaseUrl = process.env.REACT_APP_BASE_URL;

export const RefreshToken = async () => {
  const refreshToken = localStorage.getItem("refreshToken");
  const { data } = await axios.post(`${BaseUrl}/auth/refresh-token`, {
    refreshToken
  });
  localStorage.setItem("accessToken", data.data.accessToken);
};
